__webpack_require__.p = "https://barefootcoders.com/";